module.exports = __webpack_public_path__ + "img/Rectangle Copy 72@2x.1dfede5c.png";